module.exports = __webpack_public_path__ + "img/Wp_2037.01221b9e.png";